import { constantType } from './Type';

const constant: constantType = {
  DOMAIN_OWNER: 'speedbox',
  protocol: 'http',
  DOMAIN: 'https://dhy04qbiasrf1.cloudfront.net/',
  API_DOMAIN: 'https://dhy04qbiasrf1.cloudfront.net/preprod',
  API_URI: '/preprod/api/v2',
  // API_URI: 'https://d3jhzv3gzqmxuo.cloudfront.net/staging/api/v2',
  WEBSOCKET_URI: 'ws://2.speedboxapp.com/development/speedbox/api/v1',
  API_URI_PATHNAME: '/preprod/api/v2',
  razorKey: 'rzp_test_LIOk4AYGgVRnDY',
  trackingUrl: 'https://speedboxapp.com/track?orderNumber=',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBFD_fSwbp29dcajB97ReaHX2SB9V1VMvI',
};

export default constant;
